import type { HeadingWithAccentedText as HeadingWithAccentedTextType } from '@ps/web-martech-cms-types';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './HeadingWithAccentedText.scss';

export interface Props extends HeadingWithAccentedTextType {
  className?: string;
}

const HeadingWithAccentedText: React.FC<HeadingWithAccentedTextType & Partial<ClassNameProp>> = ({
  level = 'h1',
  text,
  alignment,
  anchor,
  className,
  size,
  accented_text: accentedText,
  accented_color: accentedColor,
  accented_on_new_row: accentedOnNewRow = false
}) => {
  const headingTitle = text;

  if (!headingTitle && !accentedText) {
    return null;
  }

  const getSize = (element: string) => {
    switch (element) {
      case 'h1':
        return 'l';
      case 'h2':
        return 'm';
      case 'h3':
        return 's';
      default:
        return 'xs';
    }
  };

  const getHeadingClassName = (size: HeadingWithAccentedTextType['size']) => {
    switch (size) {
      case 'xxl':
        return styles.xxl;
      case 'xl':
        return styles.xl;
      case 'l':
        return styles.l;
      case 'm':
        return styles.m;
      case 's':
        return styles.s;
      default:
        return styles.xs;
    }
  };

  const El = level;
  const headingClassName = getHeadingClassName(size || getSize(level));

  return (
    <El
      id={anchor}
      className={classNames(headingClassName, className, alignment && styles[alignment])}
    >
      {headingTitle}{' '}
      {accentedText && (
        <span style={{ color: accentedColor, display: accentedOnNewRow ? 'block' : 'inline' }}>
          {accentedText}
        </span>
      )}
    </El>
  );
};

export default HeadingWithAccentedText;
